import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, Typography} from "@material-tailwind/react";
import React, {useContext, useState} from "react";
import {ServiceSideCostPaymentContext} from "../../context/service_side_cost_payment";
import {
  updateCancelServiceSideCostPayment,
  updateServiceSideCostPayment
} from "../../services/service/service_side_cost_payment";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import dict from "../../helper/dict";
import FileCell from "../system/fileViewer";

export function ServiceSideCostPaymentForm() {

  const {
    serviceSideCostPayment,
    setServiceSideCostPayment,
    setLastDataRefresh,
    setOpen,
    open,
  } = useContext(ServiceSideCostPaymentContext);

  const handleOpen = () => setOpen(!open);

  const [buttonLoading, setButtonLoading] = useState(false);

  const save = async () => {
    setButtonLoading(true)
    const data = serviceSideCostPayment
    let result;

    result = await updateServiceSideCostPayment(data);


    if (result.status === 200) {
      setServiceSideCostPayment(false)
      setLastDataRefresh(Date.now())
      handleOpen()
      setButtonLoading(false)
    } else {
      setButtonLoading(false)
    }
  };

  const save_cancel = async () => {
    setButtonLoading(true)
    const data = serviceSideCostPayment
    let result;

    result = await updateCancelServiceSideCostPayment(data);


    if (result.status === 200) {
      setServiceSideCostPayment(false)
      setLastDataRefresh(Date.now())
      handleOpen()
      setButtonLoading(false)
    } else {
      setButtonLoading(false)
    }
  };

  if (serviceSideCostPayment) {
    return (
      <>
        <Dialog open={open} handler={handleOpen}
                animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
          <DialogHeader className="border-b">
            <Typography>بررسی تسویه دولتی و جانبی</Typography>
          </DialogHeader>
          <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

            <div className="grid grid-cols-1 gap-4">

              <div
                className="grid grid-row justify-between max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("user")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${serviceSideCostPayment.person_name}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-between max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("user_phone")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${persianNumberFormat(serviceSideCostPayment.person_phone)}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-between max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("agent")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${serviceSideCostPayment.agent_name}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-between max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("agent_phone")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${persianNumberFormat(serviceSideCostPayment.agent_phone)}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-between max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("branch")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${serviceSideCostPayment.branch_name}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-between max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("title")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${serviceSideCostPayment.title}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-between max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("description")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${serviceSideCostPayment.description}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-between max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("side_cost")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${persianNumberFormat(serviceSideCostPayment.agent_share, true)} ریال`}
                  </Typography>
                </div>
              </div>

              {serviceSideCostPayment.file?.length > 0 &&
                <div
                  className="grid grid-row justify-between max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
                >
                  <div className="grid grid-col min-w-fit">
                    <Typography color="blue-gray">
                      {`${dict("receipt")}:`}
                    </Typography>
                  </div>
                  <FileCell fileCode={serviceSideCostPayment?.file}/>
                </div>
              }


            </div>

          </DialogBody>
          <DialogFooter className="space-x-2">
            <Button variant="text" color="gray" onClick={handleOpen}>
              <span>انصراف</span>
            </Button>
            <Button variant="outlined" color="gray" onClick={save_cancel} disabled={buttonLoading}
                    loading={buttonLoading} className="ml-1">
              <span>لغو هزینه جانبی</span>
            </Button>
            {serviceSideCostPayment.file?.length > 0 && serviceSideCostPayment.status === "agent_payed" &&
              <Button variant="gradient" color="gray" onClick={save} disabled={buttonLoading} loading={buttonLoading}
                      className="ml-1">
                <span>تسویه هزینه جانبی</span>
              </Button>
            }
          </DialogFooter>
        </Dialog>
      </>
    );
  }
}